import fetchAPI from '../utils/service';

function getFooterMenuListRequest() {
  return {
    type: 'GET_FOOTER_MENU_LIST_REQUEST',
  };
}
function getFooterMenuListSuccess(payload) {
  return {
    type: 'GET_FOOTER_MENU_LIST_SUCCESS',
    payload,
  };
}
function getFooterMenuListFailure() {
  return {
    type: 'GET_FOOTER_MENU_LIST_FAILURE',
  };
}

function getFooterMenuList() {
  return async (dispatch) => {
    await dispatch(getFooterMenuListRequest());
    try {
      const res = await fetchAPI({
        endpoints: '/footer-menu',
      });
      if (res.status === 200) {
        await dispatch(getFooterMenuListSuccess(res.data));
      } else {
        await dispatch(getFooterMenuListFailure());
      }
    } catch (error) {
      await dispatch(getFooterMenuListFailure());
    }
  };
}

function createFooterMenuRequest() {
  return {
    type: 'CREATE_FOOTER_MENU_REQUEST',
  };
}
function createFooterMenuSuccess(data) {
  return {
    type: 'CREATE_FOOTER_MENU_SUCCESS',
    payload: {
      data,
    },
  };
}
function createFooterMenuFailure() {
  return {
    type: 'CREATE_FOOTER_MENU_FAILURE',
  };
}

function createFooterMenu({ data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(createFooterMenuRequest());
    try {
      const res = await fetchAPI({
        method: 'POST',
        data,
        endpoints: '/footer-menu',
      });
      if (res.status === 201) {
        await dispatch(createFooterMenuSuccess(res.data));
        await response.success();
        dispatch(getFooterMenuList());
      } else {
        await dispatch(createFooterMenuFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(createFooterMenuFailure());
      await response.failure();
    }
  };
}

function editFooterMenuRequest() {
  return {
    type: 'EDIT_FOOTER_MENU_REQUEST',
  };
}
function editFooterMenuSuccess(data, _id) {
  return {
    type: 'EDIT_FOOTER_MENU_SUCCESS',
    payload: {
      data,
      _id,
    },
  };
}
function editFooterMenuFailure() {
  return {
    type: 'EDIT_FOOTER_MENU_FAILURE',
  };
}

function editFooterMenu({ _id, data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(editFooterMenuRequest());
    try {
      const res = await fetchAPI({
        method: 'PATCH',
        data,
        endpoints: `/footer-menu/${_id}`,
      });
      if (res.status === 200) {
        await dispatch(editFooterMenuSuccess(res.data, _id));
        await response.success();
        dispatch(getFooterMenuList());
      } else {
        await dispatch(editFooterMenuFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(editFooterMenuFailure());
      await response.failure();
    }
  };
}

function deleteFooterMenuRequest() {
  return {
    type: 'DELETE_FOOTER_MENU_REQUEST',
  };
}
function deleteFooterMenuSuccess(_id) {
  return {
    type: 'DELETE_FOOTER_MENU_SUCCESS',
    payload: {
      _id,
    },
  };
}
function deleteFooterMenuFailure() {
  return {
    type: 'DELETE_FOOTER_MENU_FAILURE',
  };
}

function deleteFooterMenu({ _id, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(deleteFooterMenuRequest());
    try {
      const res = await fetchAPI({
        method: 'DELETE',
        endpoints: `/footer-menu/${_id}`,
      });
      if (res.status === 200) {
        await dispatch(deleteFooterMenuSuccess(_id));
        await response.success();
      } else {
        await dispatch(deleteFooterMenuFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(deleteFooterMenuFailure());
      await response.failure();
    }
  };
}

export {
  getFooterMenuList,
  createFooterMenu,
  editFooterMenu,
  deleteFooterMenu,
};



// WEBPACK FOOTER //
// ./src/actions/footer-menu.js